import axios from 'axios';

export async function jwtInterceptor(msalInstance) {
    axios.interceptors.request.use(async(config) => {

        // E2E test seam: Playwright injects window.__E2E_TOKEN__ (a full "Bearer <jwt>" value) so
        // browser-driven tests can attach auth without a real MSAL session. This global is never
        // set in any real deployment, so this branch is inert in production.
        if (typeof window !== 'undefined' && window.__E2E_TOKEN__) {
            config.headers.setAuthorization(window.__E2E_TOKEN__);
            return config;
        }

        const accounts = msalInstance.getAllAccounts();
        const account = accounts[0];        
        const r = {
            scopes: [window.config.apimScope],
            account: account
          };

        var response = await msalInstance.acquireTokenSilent(r);
        config.headers.setAuthorization(`Bearer ${response.accessToken}`);
        return config;
    });
}